import { create, v } from '@dojo/framework/core/vdom';

import * as css from './Text.m.css';

type Typography =
	| 'none'
	| 'hero-primary'
	| 'hero-alternate'
	| 'callout-head'
	| 'hero-subhead'
	| 'section'
	| 'subhead'
	| 'smaller-subhead'
	| 'large-body'
	| 'body';

export interface TextProperties {
	uppercase?: boolean;
	align?: 'left' | 'center';
	as?: string;
	bold?: boolean;
	italic?: boolean;
	type?: Typography;
	responsive?: Typography;
}

const typeToElementMap: { [index: string]: string } = {
	none: 'span',
	'hero-primary': 'h1',
	'hero-alternate': 'h1',
	'callout-head': 'h2',
	'hero-subhead': 'h2',
	section: 'h2',
	subhead: 'h3',
	'smaller-subhead': 'h3',
	'large-body': 'p',
	body: 'p',
	standard: 'span'
};

const factory = create().properties<TextProperties>();

export const Text = factory(function Text({ children, properties }) {
	let {
		uppercase = false,
		type = 'standard',
		as = typeToElementMap[type],
		align,
		bold = false,
		italic = false,
		responsive
	} = properties();

	const childNodes = children();
	const [firstChild] = childNodes;

	if (as === 'p' && (childNodes.length > 1 || typeof firstChild !== 'string')) {
		as = 'div';
	}

	const classes = [
		css.root,
		uppercase && css.uppercase,
		type === 'standard' && css.body,
		type === 'body' && css.body,
		type === 'large-body' && css.largeBody,
		type === 'smaller-subhead' && css.smallerSubhead,
		type === 'subhead' && css.subhead,
		type === 'section' && css.section,
		type === 'hero-subhead' && css.heroSubhead,
		type === 'callout-head' && css.calloutHead,
		type === 'hero-primary' && css.heroPrimary,
		type === 'hero-alternate' && css.heroAlternate,
		responsive === 'body' && css.responsiveBody,
		responsive === 'large-body' && css.responsiveLargeBody,
		responsive === 'smaller-subhead' && css.responsiveSmallerSubhead,
		responsive === 'subhead' && css.responsiveSubhead,
		responsive === 'section' && css.responsiveSection,
		responsive === 'hero-subhead' && css.responsiveHeroSubhead,
		responsive === 'callout-head' && css.responsiveCalloutHead,
		responsive === 'hero-primary' && css.responsiveHeroPrimary,
		align === 'center' && css.center,
		bold && css.bold,
		italic && css.italic
	];
	return v(as, { classes }, childNodes);
});

export default Text;
